import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import camelCase from 'lodash-es/camelCase';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicDetails } from 'lcc-state/interfaces';
import { TopicWidgetProperties } from 'book-widgets/interfaces';
import { Generator } from '../topic-widgets/generator';

import css from '@holmescorp/book-widgets/css/topicpage.m.css';

const factory = create({ theme }).properties<TopicWidgetProperties>();

export const Ph = factory(({ properties, middleware: { theme } }) => {
	const { topicdata, additionalClasses = [] } = properties();
	const themeCss = theme.classes(css);
	const data: TopicDetails = topicdata as any;
	let phkid: any = ' ';
	if (data) {
		const { children = [] } = data;
		if (children.length == 1) {
			const kid: unknown = children[0];
			if (typeof kid === 'string') {
				const output: string = kid;
				// look for icon reference and add as a class instead
				if (output.includes('_icons_')) {
					additionalClasses.push(camelCase(output));
				} else {
					phkid = kid;
				}
			} else if (typeof kid === 'number') {
				const { attributes = {} } = data;
				const outputclass: string = (attributes as any).outputclass || '';
				if (outputclass.includes('currency')) {
					phkid = kid.toFixed(2);
				} else {
					phkid = String(kid);
				}
			} else {
				// non-text child
				phkid = w(Generator, { skipTitle: false, insection: true, topic: topicdata as any });
			}
		} else if (children.length > 1) {
			// Has more than one child, automatically use Generator
			phkid = w(Generator, { skipTitle: false, insection: true, topic: topicdata as any });
		}
	}

	return v('ph', { classes: [themeCss.ph, ...additionalClasses] }, [phkid]);
});
